import { find, get, compact } from 'lodash';
import React from 'react';
import SelectField from '../../forms/SelectField';

const CopyPartnerClearance = ({ staticData = {}, data, onInput, dependencies = {} }) => {
    const names = compact(
        (staticData.for || []).map(id => {
            return get(
                find(dependencies.partners, x => x.id === id),
                'name',
                ''
            );
        })
    ).join(', ');
    return (
        <React.Fragment>
            <p className="u-margin-bottom-2 u-italic">
                The clearance of the selected media partner will be copied to <span className="u-bold">{names}</span>{' '}
                for the event <span className="u-bold">{staticData.eventName}</span>.
            </p>
            <SelectField
                label="Select Media Partner"
                onChange={onInput}
                name={'partnerId'}
                items={(dependencies.partners || []).map(x => ({ value: x.id, label: x.name }))}
                value={data.partnerId}
            />
        </React.Fragment>
    );
};

export default CopyPartnerClearance;



// WEBPACK FOOTER //
// ./src/components/admin/lineup/CopyPartnerClearance.js